import { useMemo } from "react";

export const useCalculateData = (transformedData, activeIndex, totalValue, showOriginalValue) => {
  return useMemo(() => {
    return transformedData.map(({ id, title, value, color, opacity }, index) => {
      const isActive = index === activeIndex;
      const fill = opacity && opacity < 1 ? `${color}${opacity * 100}` : color;

      const _totalValue = totalValue === 0 ? 1 : totalValue;

      const roundedValue = Math.round((value / _totalValue) * 100 * 10) / 10;
      const labelValue = showOriginalValue
        ? value
        : roundedValue != undefined
        ? `${roundedValue?.toFixed(1)}%`
        : null;

      return {
        id,
        label: title,
        fill,
        isActive,
        value: roundedValue,
        originalValue: value,
        labelValue
      };
    });
  }, [transformedData, activeIndex, totalValue, showOriginalValue]);
};
